<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="m13.67 14.1-.95-3.14-.07-.12-.04-.07a1.3 1.3 0 0 0-.14-.17.53.53 0 0 0-.1-.08l-.14-.08-.09-.05h-.1c-.02 0-.05 0-.08-.02-.1 0-.2 0-.29.03a.82.82 0 0 0-.56.54l-.97 3.14v.04a1.82 1.82 0 0 0 1.77 2.38c1.01 0 1.85-.83 1.85-1.85 0-.18-.04-.34-.09-.5v-.05Z"
    />
    <path
      d="m21.66 17.3-3.28-7.9a3.4 3.4 0 0 0-3.15-2.1H12.8V3.66h6.3a.84.84 0 0 0 0-1.67H4.82a.83.83 0 0 0-.83.83c0 .47.38.84.83.84h6.3V7.3H8.91c-1.35 0-2.58.8-3.13 2.03L2.3 17.22A3.4 3.4 0 0 0 5.41 22h13.1a3.41 3.41 0 0 0 3.16-4.7h-.01Zm-9.7 2.66a5.32 5.32 0 1 1 .02-10.64 5.32 5.32 0 0 1-.02 10.64Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
